import { render, staticRenderFns } from "./MedecinDetailHcactivitecreate.vue?vue&type=template&id=667c3cbf&"
import script from "./MedecinDetailHcactivitecreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailHcactivitecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports